export default __webpack_public_path__ + "static/media/default_photo.c2c58b21.jpg";